import type { ReleasesFilters } from '~/modules/artist-roster/hooks/useReleasesUrlParams/types';

export const DEFAULT_RELEASES_FILTERS: ReleasesFilters = {
  searchText: undefined,
  releaseType: undefined,
  role: undefined,
};
